import { render } from "./AddToCart.vue?vue&type=template&id=adf8c9b4&ts=true"
import script from "./AddToCart.vue?vue&type=script&lang=ts"
export * from "./AddToCart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__